export class Asegurado {
  listado_asegurados: Array<any> = [];
  asegurado_seleccionado: any;
  waitingSiniestros: boolean = false;
}
